import * as types from './types';
import * as api from './api';

export const login = (username, password, ipAddress,deviceInfo) => ({
  type: types.LOGIN,
  payload: api.login(username, password, ipAddress,deviceInfo),
  meta: {
    ipAddress,
    username,
    password,
    deviceInfo
  }
});



export const logout = () => ({
  type: types.LOGOUT,
  payload: api.logout()
});

export const resetPopError = () => ({
  type: 'RESET_STATUS'
});



// WEBPACK FOOTER //
// ./src/state/auth/actions.js